"use client";

import React from "react";
import { ButtonStyleType, SpacingType } from "@/types";
import { sectionVariants } from "@/types";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import parse from "html-react-parser";
import { SectionWrapper } from "../components/SectionWraper";

interface ContentItem {
  title?: string;
  content?: string;
  hasButton?: boolean;
  buttonText?: string;
  buttonLink?: string;
  buttonStyle?: ButtonStyleType;
  microCopy?: string;
}

interface Feature11Props { 
  darkMode?: boolean; 
  variant?: sectionVariants;
  spacing?: SpacingType;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  themeChangeOnScroll?: boolean;
  leftContent?: ContentItem;
  rightContent?: ContentItem;
  attributes?: React.HTMLProps<HTMLElement>;
}

const ContentItem = ({
  title,
  content,
  hasButton,
  buttonStyle,
  buttonText,
  buttonLink,
  microCopy,
}: ContentItem) => {
  return (
    <div className="w-full shrink lg:w-1/2 flex flex-col gap-8 text-center lg:text-left">
      {title && (
        <h2>
          {parse(title)}
        </h2>
      )}
      {content && (
        <div className="text-muted-foreground paragraph-lg">
          {parse(content)}
        </div>
      )}
      {hasButton && (
        <>
          <div className="flex flex-col">
            <div>
            <Button 
              variant={buttonStyle}
              size="lg"
              asChild
              className="w-full sm:w-auto"
            >
              <Link href={buttonLink ?? ""}>
                {buttonText}
              </Link>
            </Button>
            </div>
            {microCopy && (
              <div className="text-center lg:text-left text-muted-foreground paragraph-sm mt-2">
                {parse(microCopy)}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

const Feature11 = ({
  darkMode = false,
  variant = "A",
  spacing,
  usedInPageNav = false,
  pageNavTitle = "Feature 11",
  themeChangeOnScroll = false,
  leftContent,
  rightContent,
  attributes,
}: Feature11Props) => {  
  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      themeChangeOnScroll={themeChangeOnScroll}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="feature11"
      attributes={attributes}
    >
      <div className="container">
        <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-16" data-aos="fade-up">
          <ContentItem {...leftContent} />
          <ContentItem {...rightContent} />
        </div>
      </div>
    </SectionWrapper>
  );
};

export { Feature11 };



